const data = {
  twitter: 'https://twitter.com/madhikarma',
  github: 'https://github.com/madhikarma',
  linkedin: 'https://www.linkedin.com/in/smadhikarmi/',
  email: null,
}

export default data
